<script setup>
import { ref } from 'vue';
import { router, Head } from '@inertiajs/vue3';
import JetBanner from '@/Jetstream/Banner.vue';
import JetApplicationHeader from '@/Jetstream/ApplicationHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

const props = defineProps({
    title: String,
    auditor: Boolean
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";

const showingNavigationDropdown = ref(false);

const switchToTeam = (team) => {
    router.put(route(urlNamePrefix+'current-team.update'), {
        team_id: team.id,
    }, {
        preserveState: false,
    });
};

const logout = () => {
    router.post(route(urlNamePrefix+'logout'));
};


</script>

<template>

    <AppTheming />

   <div class="flex-content-container">
        <Head :title="title" />

        <JetBanner />

        <JetApplicationHeader :auditor="auditor"/>

        <div class="min-h-screen bg-gray-100">

            <!-- Page Heading -->
            <header v-if="$slots.header" class="bg-white shadow">
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <slot name="header" />
                </div>
            </header>

            <!-- Page Content -->
            <main>
                <slot />
            </main>
        </div>

        <JetApplicationFooter :programme="programme" :organisation="organisation" />
    </div>
</template>
